'use client'

import { alpha } from '@mui/material/styles'
import { Alert, IconButton } from '@mui/material'

import {
	ErrorTwoTone as ErrorTwoToneIcon,
	CheckCircleTwoTone as CheckCircleTwoToneIcon,
	WarningTwoTone as WarningTwoToneIcon,
	InfoTwoTone as InfoTwoToneIcon,
	CloseTwoTone as CloseTwoToneIcon
} from '@mui/icons-material'

import { closeSnackbar } from 'notistack'

// Types
import type { AlertItemProps } from '@/types/components/atoms/items/alert'

const AlertItemAtom = (props: AlertItemProps) => {
	// Props
	const { ref, id, variant, severity, children } = props

	// Variables
	const alphaValue = variant === 'outlined' ? 0.1 : 0.7

	return (
		<Alert
			ref={ref}
			variant={variant ?? 'filled'}
			severity={severity}
			iconMapping={{
				error: <ErrorTwoToneIcon fontSize="inherit" />,
				success: <CheckCircleTwoToneIcon fontSize="inherit" />,
				warning: <WarningTwoToneIcon fontSize="inherit" />,
				info: <InfoTwoToneIcon fontSize="inherit" />
			}}
			action={
				id && (
					<IconButton
						size="small"
						color="inherit"
						aria-label="close"
						onClick={() => closeSnackbar(id)}
						sx={{
							borderRadius: 1,
							'& .MuiTouchRipple-root .MuiTouchRipple-child': { borderRadius: 1 }
						}}
					>
						<CloseTwoToneIcon fontSize="small" />
					</IconButton>
				)
			}
			sx={theme => ({
				bgcolor:
					severity === 'success'
						? alpha(theme.palette.success.main, alphaValue)
						: severity === 'info'
							? alpha(theme.palette.info.main, alphaValue)
							: severity === 'warning'
								? alpha(theme.palette.warning.main, alphaValue)
								: alpha(theme.palette.error.main, alphaValue),
				backdropFilter: 'blur(5px)'
			})}
		>
			{children}
		</Alert>
	)
}

export default AlertItemAtom
